function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Spinner from "@common/components/Spinner";
import { generateRequestBody } from "@common/components/order/subscriptions/utils";
import { formatDate, formatPrice, replaceWith } from "@common/services/helpers";
import { convertCurrency, stripCurrencyConversion } from "@common/services/helpers";
import request from "@common/services/request";
import { ENTITY_TYPE_PLAN } from "@config/constants";
import { ENTITY_TYPE_PROMOTION, SNACKBAR_AUTOHIDE_TIMEOUT, SNACKBAR_VARIANT_ERROR, SUBSCRIPTION_PLAN_BASIC_ID } from "@config/constants";
import { COUNTRIES } from "@config/countries";
import { Button } from "@material-ui/core";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Popover from "@material-ui/core/Popover";
import { castArray, isArray, isEmpty, isNil } from "lodash";
import { withSnackbar } from "notistack";
import React, { Component, useCallback, useEffect, useRef, useState } from "react";
import Sheet from "react-modal-sheet";
import { connect } from "react-redux";
var filterNegativeZero = function(value) {
    return value === 0 ? 0 : value;
};
var PromoCode = withSnackbar(function(props) {
    var _useState = _sliced_to_array(useState(""), 2), inputValue = _useState[0], setInputValue = _useState[1];
    var _useState1 = _sliced_to_array(useState(null), 2), activeCoupon = _useState1[0], setActiveCoupon = _useState1[1];
    var _useState2 = _sliced_to_array(useState(), 2), expanded = _useState2[0], setExpanded = _useState2[1];
    var onApply = props.onApply, i18n = props.i18n, enqueueSnackbar = props.enqueueSnackbar;
    var _useState3 = _sliced_to_array(useState(false), 2), loading = _useState3[0], setLoading = _useState3[1];
    var testPromoCode = function() {
        var _ref = _async_to_generator(function() {
            var data, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        setLoading(true);
                        return [
                            4,
                            request({
                                method: "POST",
                                url: "users/me/estimate",
                                data: _object_spread_props(_object_spread({}, generateRequestBody(props.orderSummary)), {
                                    coupons: [
                                        inputValue
                                    ]
                                })
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        onApply === null || onApply === void 0 ? void 0 : onApply(inputValue);
                        setActiveCoupon(inputValue);
                        setLoading(false);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        setLoading(false);
                        enqueueSnackbar(i18n.order.invalidCoupon, {
                            variant: SNACKBAR_VARIANT_ERROR,
                            autoHideDuration: SNACKBAR_AUTOHIDE_TIMEOUT
                        });
                        console.error(error);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function testPromoCode() {
            return _ref.apply(this, arguments);
        };
    }();
    var onChangeInputValue = useCallback(function(e) {
        setInputValue(e.target.value);
    }, []);
    var toggleExpand = function() {
        if (!isNil(activeCoupon)) {
            setActiveCoupon(null);
            setInputValue("");
        } else {
            setExpanded(function(e) {
                return !e;
            });
        }
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "promo-code-container ".concat(expanded ? "expanded" : ""),
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "promo-code",
                onClick: toggleExpand,
                onKeyDown: toggleExpand,
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: "promo-code-title",
                        children: i18n.order.promoCode
                    }),
                    expanded ? "-" : "+"
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "promo-code-selector",
                children: [
                    isNil(activeCoupon) && /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx("input", {
                                type: "text",
                                value: inputValue,
                                onChange: onChangeInputValue,
                                placeholder: i18n.order.enterPromoCode
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                classes: {
                                    label: "ux-button-label"
                                },
                                className: "button raised half-width pointer",
                                onClick: testPromoCode,
                                disabled: loading || isEmpty(inputValue),
                                children: loading ? /*#__PURE__*/ _jsx(Spinner, {}) : i18n.order.enter
                            })
                        ]
                    }),
                    !isNil(activeCoupon) && /*#__PURE__*/ _jsx("span", {
                        className: "promo-code-active",
                        children: activeCoupon
                    })
                ]
            })
        ]
    });
});
var Quantity = function(props) {
    var title = props.title, _props_quantity = props.quantity, quantity = _props_quantity === void 0 ? 0 : _props_quantity, onIncrease = props.onIncrease, onDecrease = props.onDecrease;
    var disabled = quantity <= 1;
    var maxDisabled = quantity >= props.maxQuantity;
    return /*#__PURE__*/ _jsxs("div", {
        className: "quantity-container",
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: "spacer"
            }),
            /*#__PURE__*/ _jsxs("span", {
                className: "quantity-title",
                children: [
                    title,
                    ":"
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "quantity-selector",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "selector ".concat(disabled ? "disabled" : ""),
                        onClick: !disabled && onDecrease,
                        onKeyDown: !disabled && onDecrease,
                        children: "-"
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "quantity-value",
                        children: quantity
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "selector ".concat(maxDisabled ? "disabled" : ""),
                        onClick: !maxDisabled && onIncrease,
                        onKeyDown: !maxDisabled && onIncrease,
                        children: "+"
                    })
                ]
            })
        ]
    });
};
function getMonthNameBG(month) {
    var d = new Date();
    d.setMonth(month);
    return d.toLocaleString("bg-BG", {
        month: "long"
    });
}
function TimePeriodDiscountInfo(props) {
    // price - price for 1 month
    var i18n = props.i18n, period = props.period, priceLocalCurrency = props.priceLocalCurrency, invoiceItem = props.invoiceItem, itemCurrency = props.itemCurrency, currencyConversion = props.currencyConversion;
    var discountedPrice = convertCurrency(invoiceItem === null || invoiceItem === void 0 ? void 0 : invoiceItem.amount, itemCurrency, currencyConversion).value;
    var currency = (currencyConversion === null || currencyConversion === void 0 ? void 0 : currencyConversion.currency) || itemCurrency;
    var subStartingMonth = new Date((invoiceItem === null || invoiceItem === void 0 ? void 0 : invoiceItem.dateFrom) * 1000).getMonth();
    var _useState = _sliced_to_array(useState(false), 2), menuOpen = _useState[0], setMenuOpen = _useState[1];
    var anchorRef = useRef(null);
    var prices = new Array(period).fill(0);
    var priceSummed = discountedPrice;
    for(var i = period - 1, last = Math.min(priceLocalCurrency, discountedPrice); i >= 0; i--){
        if (priceSummed <= 0) break;
        prices[i] = last;
        priceSummed -= last;
        last = Math.min(last, priceSummed);
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "row",
                ref: anchorRef,
                onMouseEnter: function() {
                    return setMenuOpen(true);
                },
                children: [
                    /*#__PURE__*/ _jsxs("span", {
                        className: "icon icon-info",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "path1"
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: "path2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "period-times-price",
                        children: "".concat(period, " x ").concat(formatPrice(priceLocalCurrency, currency), "/").concat(i18n.order.monthShort)
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Popover, {
                anchorEl: anchorRef.current,
                open: menuOpen,
                onClose: function() {
                    return setMenuOpen(false);
                },
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "price-partition-menu",
                    onMouseLeave: function() {
                        return setMenuOpen(false);
                    },
                    onMouseEnter: function() {
                        return setMenuOpen(true);
                    },
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "column",
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    className: "partition",
                                    children: i18n.order.partition
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: "by-months",
                                    children: i18n.order.byMonths
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: "time-period",
                                    children: "".concat(formatDate(invoiceItem === null || invoiceItem === void 0 ? void 0 : invoiceItem.dateFrom), " - ").concat(formatDate(invoiceItem === null || invoiceItem === void 0 ? void 0 : invoiceItem.dateTo))
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "column",
                            children: prices.map(function(monthPrice, index) {
                                var monthName = getMonthNameBG((subStartingMonth + index) % 12);
                                return /*#__PURE__*/ _jsxs("div", {
                                    className: "menu-item",
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "month",
                                            children: monthName
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "price",
                                            children: formatPrice(monthPrice, currency)
                                        })
                                    ]
                                }, monthName);
                            })
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "column total-wrapper",
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    className: "total",
                                    children: "".concat(i18n.order.prepaymentForPeriod, ":")
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: "total-price",
                                    children: formatPrice(discountedPrice, currency)
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
var OrderSection = function(props) {
    var _invoiceEstimate_lineItems;
    var title = props.title, _props_order = props.order, order = _props_order === void 0 ? [] : _props_order, invoiceEstimate = props.invoiceEstimate, prismicItems = props.prismicItems, i18n = props.i18n, color = props.color, _props_discountItems = props.discountItems, discountItems = _props_discountItems === void 0 ? [] : _props_discountItems, renderItemFooter = props.renderItemFooter, period = props.period, currencyConversion = props.currencyConversion;
    var items = isArray(order) ? order : [
        order
    ];
    var invoiceItems = (invoiceEstimate === null || invoiceEstimate === void 0 ? void 0 : (_invoiceEstimate_lineItems = invoiceEstimate.lineItems) === null || _invoiceEstimate_lineItems === void 0 ? void 0 : _invoiceEstimate_lineItems.reduce(function(acc, item) {
        acc[item.entityId] = item;
        return acc;
    }, {})) || {};
    var invoiceItemKeys = Object.keys(invoiceItems);
    var hasEstimates = items === null || items === void 0 ? void 0 : items.every(function(item) {
        return invoiceItemKeys.includes(item === null || item === void 0 ? void 0 : item.id);
    });
    var hasDiscountItems = !isEmpty(discountItems);
    var hasOrder = !isEmpty(order);
    // If there are no items in the order, return null
    if (hasDiscountItems ? false : !hasOrder || isEmpty(invoiceEstimate)) {
        return null;
    }
    var mergedItems = _to_consumable_array(discountItems.map(function(item) {
        return _object_spread_props(_object_spread({}, item), {
            isDiscount: true
        });
    })).concat(_to_consumable_array(items));
    var lineItemsPrototype = mergedItems.map(function(item, itemIndex, ref) {
        var _prismicItem_title, _prismicItem_perks_title, _prismicItem_subtitle;
        var invoiceItem = invoiceItems[item.id];
        if (!invoiceItem && !item.isDiscount) return null;
        var entityType = invoiceItem === null || invoiceItem === void 0 ? void 0 : invoiceItem.entityType;
        var prismicItem = castArray(prismicItems).find(function(e) {
            return (e === null || e === void 0 ? void 0 : e.id) === (item === null || item === void 0 ? void 0 : item.id);
        });
        var title = prismicItem === null || prismicItem === void 0 ? void 0 : (_prismicItem_title = prismicItem.title) === null || _prismicItem_title === void 0 ? void 0 : _prismicItem_title.text;
        var subtitle = entityType === ENTITY_TYPE_PLAN ? prismicItem === null || prismicItem === void 0 ? void 0 : (_prismicItem_perks_title = prismicItem.perks_title) === null || _prismicItem_perks_title === void 0 ? void 0 : _prismicItem_perks_title.text : prismicItem === null || prismicItem === void 0 ? void 0 : (_prismicItem_subtitle = prismicItem.subtitle) === null || _prismicItem_subtitle === void 0 ? void 0 : _prismicItem_subtitle.text;
        var hasDiscount = !isNil(invoiceItem === null || invoiceItem === void 0 ? void 0 : invoiceItem.itemLevelDiscountAmount) && !isNil(invoiceItem === null || invoiceItem === void 0 ? void 0 : invoiceItem.amount) && (invoiceItem === null || invoiceItem === void 0 ? void 0 : invoiceItem.itemLevelDiscountAmount) > 0;
        var filteredItems = ref.filter(function(e) {
            return invoiceItemKeys.includes(e.id);
        });
        var itemPriceBeforeCredits = (item === null || item === void 0 ? void 0 : item.price) ? convertCurrency(item.price, item === null || item === void 0 ? void 0 : item.currencyCode, currencyConversion).value : null;
        var hasTimePeriodDiscount = !isNil(period) && period > 1;
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                itemIndex !== 0 && !renderItemFooter && filteredItems.length > 1 && /*#__PURE__*/ _jsx("span", {
                    className: "separator"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "item ".concat(itemIndex === 0 ? "first" : ""),
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "column",
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "name",
                                        children: title || item.description
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "row",
                                        children: /*#__PURE__*/ _jsx("span", {
                                            className: "subtitle",
                                            children: subtitle
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "column",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "row price-container",
                                        children: [
                                            hasDiscount && /*#__PURE__*/ _jsx("span", {
                                                className: "original-price",
                                                children: formatPrice(invoiceItem.amount, item.currencyCode, currencyConversion)
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "price",
                                                children: formatPrice(item.isDiscount ? filterNegativeZero(-item.value) : hasDiscount ? invoiceItem.amount - invoiceItem.itemLevelDiscountAmount : invoiceItem.amount, item.currencyCode, currencyConversion)
                                            })
                                        ]
                                    }),
                                    hasTimePeriodDiscount && /*#__PURE__*/ _jsx(TimePeriodDiscountInfo, {
                                        i18n: i18n,
                                        period: period,
                                        priceLocalCurrency: itemPriceBeforeCredits,
                                        invoiceItem: invoiceItem,
                                        itemCurrency: item.currencyCode,
                                        currencyConversion: currencyConversion
                                    }),
                                    hasDiscount && /*#__PURE__*/ _jsx("span", {
                                        className: "discount",
                                        children: replaceWith(i18n.order.discount, Math.floor(invoiceItem.itemLevelDiscountAmount * 100 / invoiceItem.amount))
                                    }),
                                    !isEmpty(item === null || item === void 0 ? void 0 : item.includedIn) && /*#__PURE__*/ _jsx("span", {
                                        className: "discount",
                                        children: "".concat(i18n.order.includedIn, " ").concat(item.includedIn)
                                    })
                                ]
                            })
                        ]
                    })
                }, "".concat(item.isDiscount ? item.description : item.id)),
                renderItemFooter && /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            className: "separator"
                        }),
                        renderItemFooter(item)
                    ]
                })
            ]
        });
    });
    // If all items are empty in the section, return null
    if (lineItemsPrototype.every(isEmpty)) return null;
    return /*#__PURE__*/ _jsxs("div", {
        className: "order-section-container",
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: "title",
                children: title
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "column",
                children: lineItemsPrototype
            })
        ]
    });
};
var DEFAULT_ORDER_SUMMARY = {
    subscription: null,
    r_addons: [],
    ot_addons: [],
    coupon: null
};
var OrderSummary = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(OrderSummary, Component);
    var _super = _create_super(OrderSummary);
    function OrderSummary(props) {
        _class_call_check(this, OrderSummary);
        var _this;
        _this = _super.call(this, props);
        _define_property(_assert_this_initialized(_this), "closeBottomSheet", function() {
            var _this_bottomSheetRef, _this_props_onCloseBottomSheet, _this_props;
            (_this_bottomSheetRef = _this.bottomSheetRef) === null || _this_bottomSheetRef === void 0 ? void 0 : _this_bottomSheetRef.snapTo(1);
            (_this_props_onCloseBottomSheet = (_this_props = _this.props).onCloseBottomSheet) === null || _this_props_onCloseBottomSheet === void 0 ? void 0 : _this_props_onCloseBottomSheet.call(_this_props);
        });
        _define_property(_assert_this_initialized(_this), "callOrderChange", function(newOrder) {
            var _this_props = _this.props, _this_props_onOrderChange = _this_props.onOrderChange, onOrderChange = _this_props_onOrderChange === void 0 ? null : _this_props_onOrderChange;
            if (onOrderChange) {
                onOrderChange(newOrder);
            }
        });
        _define_property(_assert_this_initialized(_this), "toggleBottomSheet", function() {
            var _this_bottomSheetRef;
            (_this_bottomSheetRef = _this.bottomSheetRef) === null || _this_bottomSheetRef === void 0 ? void 0 : _this_bottomSheetRef.snapTo(_this.state.bottomSheetOpen ? 1 : 0);
        });
        _define_property(_assert_this_initialized(_this), "renderHeader", function() {
            var _invoiceEstimate_lineItems, _orderSummary_subscription;
            var _this_props = _this.props, i18n = _this_props.i18n, invoiceEstimate = _this_props.invoiceEstimate, _this_props_orderSummary = _this_props.orderSummary, orderSummary = _this_props_orderSummary === void 0 ? DEFAULT_ORDER_SUMMARY : _this_props_orderSummary, customTitle = _this_props.customTitle;
            var hasEstimates = !isEmpty(invoiceEstimate);
            var lineItem = invoiceEstimate === null || invoiceEstimate === void 0 ? void 0 : (_invoiceEstimate_lineItems = invoiceEstimate.lineItems) === null || _invoiceEstimate_lineItems === void 0 ? void 0 : _invoiceEstimate_lineItems.find(function(e) {
                return !isNil(e.dateTo) && !isNil(e.dateFrom) && e.dateFrom !== e.dateTo;
            });
            if (!hasEstimates || !lineItem) return null;
            var dateFrom = new Date(lineItem.dateFrom * 1000);
            var dateTo = new Date(lineItem.dateTo * 1000);
            var estimatedMonths = Math.floor((dateTo - dateFrom) / (1000 * 60 * 60 * 24 * 30)) || 1;
            var months = (orderSummary === null || orderSummary === void 0 ? void 0 : (_orderSummary_subscription = orderSummary.subscription) === null || _orderSummary_subscription === void 0 ? void 0 : _orderSummary_subscription.cfPeriod) || 1;
            var hasDifferentPeriod = estimatedMonths < months;
            var monthsText = replaceWith(months > 1 ? i18n.order.months : i18n.order.month, // Minimum should be 1 month
            months || 1);
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: "order-summary-title",
                        children: customTitle || i18n.order.periodOfBilling
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "header",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "row",
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "period",
                                        children: monthsText
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "separator",
                                        children: "\xb7"
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "dates",
                                        children: "".concat(hasDifferentPeriod ? "".concat(i18n.order.remaining, ":") : "", " ").concat(formatDate(lineItem.dateFrom), " - ").concat(formatDate(lineItem.dateTo))
                                    })
                                ]
                            }),
                            hasDifferentPeriod && /*#__PURE__*/ _jsxs("span", {
                                className: "dates",
                                children: [
                                    replaceWith(i18n.order.nextBillingDate, [
                                        monthsText
                                    ]),
                                    ":",
                                    /*#__PURE__*/ _jsxs("b", {
                                        children: [
                                            " ",
                                            formatDate(lineItem.dateTo)
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            });
        });
        _define_property(_assert_this_initialized(_this), "renderWarning", function() {
            var _userDetails_subscription, _currentSubscription_plan, _subscriptionsPrismic_billing_cycle_items_find_title_text, _subscriptionsPrismic_billing_cycle_items_find_title, _subscriptionsPrismic_billing_cycle_items_find, _subscriptionsPrismic_billing_cycle_items;
            var _this_props = _this.props, i18n = _this_props.i18n, subscription = _this_props.orderSummary.subscription, userDetails = _this_props.userDetails, subscriptionsPrismic = _this_props.subscriptionsPrismic, invoiceEstimate = _this_props.invoiceEstimate;
            var currentSubscription = userDetails === null || userDetails === void 0 ? void 0 : (_userDetails_subscription = userDetails.subscription) === null || _userDetails_subscription === void 0 ? void 0 : _userDetails_subscription[0];
            var hasEstimates = !isEmpty(invoiceEstimate);
            if (!isEmpty(subscription) && (subscription === null || subscription === void 0 ? void 0 : subscription.id) === (currentSubscription === null || currentSubscription === void 0 ? void 0 : currentSubscription.planId) || (currentSubscription === null || currentSubscription === void 0 ? void 0 : currentSubscription.planId) === SUBSCRIPTION_PLAN_BASIC_ID || !hasEstimates) {
                return null;
            }
            var currentPlan = currentSubscription === null || currentSubscription === void 0 ? void 0 : (_currentSubscription_plan = currentSubscription.plan) === null || _currentSubscription_plan === void 0 ? void 0 : _currentSubscription_plan[0];
            var subscriptionPeriod = subscriptionsPrismic === null || subscriptionsPrismic === void 0 ? void 0 : (_subscriptionsPrismic_billing_cycle_items = subscriptionsPrismic.billing_cycle_items) === null || _subscriptionsPrismic_billing_cycle_items === void 0 ? void 0 : (_subscriptionsPrismic_billing_cycle_items_find = _subscriptionsPrismic_billing_cycle_items.find(function(e) {
                return e.period === (currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.cfPeriod);
            })) === null || _subscriptionsPrismic_billing_cycle_items_find === void 0 ? void 0 : (_subscriptionsPrismic_billing_cycle_items_find_title = _subscriptionsPrismic_billing_cycle_items_find.title) === null || _subscriptionsPrismic_billing_cycle_items_find_title === void 0 ? void 0 : (_subscriptionsPrismic_billing_cycle_items_find_title_text = _subscriptionsPrismic_billing_cycle_items_find_title.text) === null || _subscriptionsPrismic_billing_cycle_items_find_title_text === void 0 ? void 0 : _subscriptionsPrismic_billing_cycle_items_find_title_text.toLowerCase();
            return /*#__PURE__*/ _jsxs("div", {
                className: "warning-wrapper",
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: "title",
                        children: i18n.common.warning
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "subtitle",
                        children: replaceWith(i18n.order.youAlreadyHavePaid, subscriptionPeriod)
                    })
                ]
            });
        });
        _this.state = {
            loading: false,
            bottomSheetOpen: false
        };
        return _this;
    }
    _create_class(OrderSummary, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                if (prevProps.closeBottomSheet !== this.props.closeBottomSheet && this.props.closeBottomSheet) {
                    this.closeBottomSheet();
                }
                // Hack to prevent body overflow when bottom sheet is open
                if (this.state.bottomSheetOpen !== prevState.bottomSheetOpen) {
                    var bodyRef = document.querySelector("body");
                    bodyRef.classList[this.state.bottomSheetOpen ? "add" : "remove"]("overflow-hidden");
                }
            }
        },
        {
            key: "renderAddress",
            value: function renderAddress() {
                var _this = this;
                var _subscriptionsPrismic_address_cart_title, _COUNTRIES_find, _subscriptionsPrismic_address_cart_info;
                var _this_props = this.props, subscriptionsPrismic = _this_props.subscriptionsPrismic, _this_props_onAddressClick = _this_props.onAddressClick, onAddressClick = _this_props_onAddressClick === void 0 ? function() {} : _this_props_onAddressClick, disableAddress = _this_props.disableAddress;
                if (disableAddress) return null;
                return /*#__PURE__*/ _jsx("div", {
                    className: "address",
                    onClick: onAddressClick,
                    onKeyDown: onAddressClick,
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "column gap-4",
                                children: [
                                    /*#__PURE__*/ _jsxs("span", {
                                        className: "address-title",
                                        children: [
                                            subscriptionsPrismic === null || subscriptionsPrismic === void 0 ? void 0 : (_subscriptionsPrismic_address_cart_title = subscriptionsPrismic.address_cart_title) === null || _subscriptionsPrismic_address_cart_title === void 0 ? void 0 : _subscriptionsPrismic_address_cart_title.text,
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "address-value",
                                        children: ((_COUNTRIES_find = COUNTRIES.find(function(param) {
                                            var code = param.code;
                                            var _this_props_billingAddress;
                                            return code === ((_this_props_billingAddress = _this.props.billingAddress) === null || _this_props_billingAddress === void 0 ? void 0 : _this_props_billingAddress.country);
                                        })) === null || _COUNTRIES_find === void 0 ? void 0 : _COUNTRIES_find.name) || "address"
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "address-info",
                                        children: subscriptionsPrismic === null || subscriptionsPrismic === void 0 ? void 0 : (_subscriptionsPrismic_address_cart_info = subscriptionsPrismic.address_cart_info) === null || _subscriptionsPrismic_address_cart_info === void 0 ? void 0 : _subscriptionsPrismic_address_cart_info.text
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: "icon icon-arrow-forward"
                            })
                        ]
                    })
                });
            }
        },
        {
            key: "renderMainContent",
            value: function renderMainContent() {
                var _this = this;
                var _invoiceEstimate_discounts_filter, _invoiceEstimate_discounts, _invoiceEstimate_discounts_filter1, _invoiceEstimate_discounts1, _subscriptionsPrismic_plans_cart_title, _subscriptionsPrismic_r_addons_cart_title, _orderSummary_subscription, _subscriptionsPrismic_ot_addons_cart_title;
                var _this_props = this.props, i18n = _this_props.i18n, subscriptionsPrismic = _this_props.subscriptionsPrismic, _this_props_orderSummary = _this_props.orderSummary, orderSummary = _this_props_orderSummary === void 0 ? DEFAULT_ORDER_SUMMARY : _this_props_orderSummary, invoiceEstimate = _this_props.invoiceEstimate, includedRAddons = _this_props.includedRAddons, disablePayment = _this_props.disablePayment;
                var hasEstimates = !isEmpty(invoiceEstimate);
                var creditsLocalizationMap = _define_property({}, ENTITY_TYPE_PROMOTION, i18n.order.promotional);
                var currencyConversion = stripCurrencyConversion(subscriptionsPrismic);
                var discounts = invoiceEstimate === null || invoiceEstimate === void 0 ? void 0 : (_invoiceEstimate_discounts = invoiceEstimate.discounts) === null || _invoiceEstimate_discounts === void 0 ? void 0 : (_invoiceEstimate_discounts_filter = _invoiceEstimate_discounts.filter(function(param) {
                    var entityType = param.entityType;
                    return entityType === null || entityType === void 0 ? void 0 : entityType.includes("credit");
                })) === null || _invoiceEstimate_discounts_filter === void 0 ? void 0 : _invoiceEstimate_discounts_filter.map(function(discount) {
                    return {
                        description: creditsLocalizationMap[discount === null || discount === void 0 ? void 0 : discount.entityType] || discount.description,
                        value: discount.amount,
                        discount: i18n.account.discount.toLowerCase(),
                        currencyCode: invoiceEstimate.currencyCode
                    };
                });
                var prepaidCredits = (invoiceEstimate === null || invoiceEstimate === void 0 ? void 0 : invoiceEstimate.creditsApplied) ? [
                    {
                        description: i18n.order.prepaid,
                        value: invoiceEstimate === null || invoiceEstimate === void 0 ? void 0 : invoiceEstimate.creditsApplied,
                        currencyCode: invoiceEstimate.currencyCode,
                        discount: i18n.account.discount.toLowerCase()
                    }
                ] : [];
                var creditItems = hasEstimates && _to_consumable_array(discounts).concat(_to_consumable_array(prepaidCredits));
                var discountItems = hasEstimates && (invoiceEstimate === null || invoiceEstimate === void 0 ? void 0 : (_invoiceEstimate_discounts1 = invoiceEstimate.discounts) === null || _invoiceEstimate_discounts1 === void 0 ? void 0 : (_invoiceEstimate_discounts_filter1 = _invoiceEstimate_discounts1.filter(function(param) {
                    var entityType = param.entityType;
                    return !(entityType === null || entityType === void 0 ? void 0 : entityType.includes("credit"));
                })) === null || _invoiceEstimate_discounts_filter1 === void 0 ? void 0 : _invoiceEstimate_discounts_filter1.map(function(discount) {
                    return {
                        description: discount.description,
                        value: discount.amount,
                        discount: i18n.account.discount.toLowerCase(),
                        currencyCode: invoiceEstimate.currencyCode
                    };
                }));
                return /*#__PURE__*/ _jsxs("div", {
                    className: "order-summary-main-content",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "order-sections",
                            children: [
                                /*#__PURE__*/ _jsx(OrderSection, {
                                    title: subscriptionsPrismic === null || subscriptionsPrismic === void 0 ? void 0 : (_subscriptionsPrismic_plans_cart_title = subscriptionsPrismic.plans_cart_title) === null || _subscriptionsPrismic_plans_cart_title === void 0 ? void 0 : _subscriptionsPrismic_plans_cart_title.text,
                                    prismicItems: subscriptionsPrismic === null || subscriptionsPrismic === void 0 ? void 0 : subscriptionsPrismic.plans_items,
                                    order: orderSummary.subscription,
                                    invoiceEstimate: invoiceEstimate,
                                    i18n: i18n,
                                    color: subscriptionsPrismic === null || subscriptionsPrismic === void 0 ? void 0 : subscriptionsPrismic.plans_subtitle_color,
                                    currencyConversion: currencyConversion
                                }),
                                /*#__PURE__*/ _jsx(OrderSection, {
                                    title: subscriptionsPrismic === null || subscriptionsPrismic === void 0 ? void 0 : (_subscriptionsPrismic_r_addons_cart_title = subscriptionsPrismic.r_addons_cart_title) === null || _subscriptionsPrismic_r_addons_cart_title === void 0 ? void 0 : _subscriptionsPrismic_r_addons_cart_title.text,
                                    prismicItems: subscriptionsPrismic === null || subscriptionsPrismic === void 0 ? void 0 : subscriptionsPrismic.r_addons_items,
                                    discountItems: includedRAddons,
                                    order: orderSummary.r_addons,
                                    invoiceEstimate: invoiceEstimate,
                                    i18n: i18n,
                                    color: subscriptionsPrismic === null || subscriptionsPrismic === void 0 ? void 0 : subscriptionsPrismic.r_addons_subtitle_color,
                                    period: orderSummary === null || orderSummary === void 0 ? void 0 : (_orderSummary_subscription = orderSummary.subscription) === null || _orderSummary_subscription === void 0 ? void 0 : _orderSummary_subscription.cfPeriod,
                                    currencyConversion: currencyConversion
                                }),
                                /*#__PURE__*/ _jsx(OrderSection, {
                                    title: subscriptionsPrismic === null || subscriptionsPrismic === void 0 ? void 0 : (_subscriptionsPrismic_ot_addons_cart_title = subscriptionsPrismic.ot_addons_cart_title) === null || _subscriptionsPrismic_ot_addons_cart_title === void 0 ? void 0 : _subscriptionsPrismic_ot_addons_cart_title.text,
                                    prismicItems: subscriptionsPrismic === null || subscriptionsPrismic === void 0 ? void 0 : subscriptionsPrismic.ot_addons_items,
                                    order: orderSummary.ot_addons,
                                    invoiceEstimate: invoiceEstimate,
                                    i18n: i18n,
                                    color: subscriptionsPrismic === null || subscriptionsPrismic === void 0 ? void 0 : subscriptionsPrismic.ot_addons_subtitle_color,
                                    renderItemFooter: function(item) {
                                        var _orderSummary_ot_addons;
                                        var ot_addon = (_orderSummary_ot_addons = orderSummary.ot_addons) === null || _orderSummary_ot_addons === void 0 ? void 0 : _orderSummary_ot_addons.find(function(e) {
                                            return e.id === item.id;
                                        });
                                        return /*#__PURE__*/ _jsx(Quantity, {
                                            title: i18n.order.quantity,
                                            maxQuantity: item.cfMaxAmount,
                                            quantity: ot_addon === null || ot_addon === void 0 ? void 0 : ot_addon.quantity,
                                            onIncrease: function() {
                                                return _this.callOrderChange(_object_spread_props(_object_spread({}, orderSummary), {
                                                    ot_addons: orderSummary.ot_addons.map(function(e) {
                                                        return e.id === item.id ? _object_spread_props(_object_spread({}, e), {
                                                            quantity: e.quantity + 1
                                                        }) : e;
                                                    })
                                                }));
                                            },
                                            onDecrease: function() {
                                                return _this.callOrderChange(_object_spread_props(_object_spread({}, orderSummary), {
                                                    ot_addons: orderSummary.ot_addons.map(function(e) {
                                                        return e.id === item.id ? _object_spread_props(_object_spread({}, e), {
                                                            quantity: e.quantity - 1
                                                        }) : e;
                                                    })
                                                }));
                                            }
                                        });
                                    },
                                    currencyConversion: currencyConversion
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(OrderSection, {
                            title: i18n.account.discount,
                            discountItems: discountItems,
                            invoiceEstimate: invoiceEstimate,
                            i18n: i18n,
                            type: "discounts",
                            currencyConversion: currencyConversion
                        }),
                        /*#__PURE__*/ _jsx(OrderSection, {
                            title: i18n.account.credits,
                            discountItems: creditItems,
                            invoiceEstimate: invoiceEstimate,
                            i18n: i18n,
                            type: "credits",
                            currencyConversion: currencyConversion
                        }),
                        hasEstimates && !disablePayment && /*#__PURE__*/ _jsx(PromoCode, {
                            i18n: i18n,
                            orderSummary: orderSummary,
                            onApply: this.props.onPromoCodeApply
                        })
                    ]
                });
            }
        },
        {
            key: "renderFooterInfo",
            value: function renderFooterInfo() {
                var _subscriptionsPrismic_plans_cart_info, _subscriptionsPrismic_plans_cart_info1, _subscriptionsPrismic_r_addons_cart_info, _subscriptionsPrismic_r_addons_cart_info1, _subscriptionsPrismic_ot_addons_cart_info, _subscriptionsPrismic_ot_addons_cart_info1;
                var _this_props = this.props, subscriptionsPrismic = _this_props.subscriptionsPrismic, _this_props_orderSummary = _this_props.orderSummary, orderSummary = _this_props_orderSummary === void 0 ? DEFAULT_ORDER_SUMMARY : _this_props_orderSummary, disableFooterInfo = _this_props.disableFooterInfo;
                if (disableFooterInfo) return null;
                return /*#__PURE__*/ _jsxs("div", {
                    className: "footer-info",
                    children: [
                        (subscriptionsPrismic === null || subscriptionsPrismic === void 0 ? void 0 : (_subscriptionsPrismic_plans_cart_info = subscriptionsPrismic.plans_cart_info) === null || _subscriptionsPrismic_plans_cart_info === void 0 ? void 0 : _subscriptionsPrismic_plans_cart_info.text) && /*#__PURE__*/ _jsx("p", {
                            children: subscriptionsPrismic === null || subscriptionsPrismic === void 0 ? void 0 : (_subscriptionsPrismic_plans_cart_info1 = subscriptionsPrismic.plans_cart_info) === null || _subscriptionsPrismic_plans_cart_info1 === void 0 ? void 0 : _subscriptionsPrismic_plans_cart_info1.text
                        }),
                        (subscriptionsPrismic === null || subscriptionsPrismic === void 0 ? void 0 : (_subscriptionsPrismic_r_addons_cart_info = subscriptionsPrismic.r_addons_cart_info) === null || _subscriptionsPrismic_r_addons_cart_info === void 0 ? void 0 : _subscriptionsPrismic_r_addons_cart_info.text) && /*#__PURE__*/ _jsx("p", {
                            children: subscriptionsPrismic === null || subscriptionsPrismic === void 0 ? void 0 : (_subscriptionsPrismic_r_addons_cart_info1 = subscriptionsPrismic.r_addons_cart_info) === null || _subscriptionsPrismic_r_addons_cart_info1 === void 0 ? void 0 : _subscriptionsPrismic_r_addons_cart_info1.text
                        }),
                        (subscriptionsPrismic === null || subscriptionsPrismic === void 0 ? void 0 : (_subscriptionsPrismic_ot_addons_cart_info = subscriptionsPrismic.ot_addons_cart_info) === null || _subscriptionsPrismic_ot_addons_cart_info === void 0 ? void 0 : _subscriptionsPrismic_ot_addons_cart_info.text) && !isEmpty(orderSummary === null || orderSummary === void 0 ? void 0 : orderSummary.ot_addons) && /*#__PURE__*/ _jsx("p", {
                            children: subscriptionsPrismic === null || subscriptionsPrismic === void 0 ? void 0 : (_subscriptionsPrismic_ot_addons_cart_info1 = subscriptionsPrismic.ot_addons_cart_info) === null || _subscriptionsPrismic_ot_addons_cart_info1 === void 0 ? void 0 : _subscriptionsPrismic_ot_addons_cart_info1.text
                        })
                    ]
                });
            }
        },
        {
            key: "renderTotalWithPayment",
            value: function renderTotalWithPayment() {
                var _this = this;
                var _this_props = this.props, i18n = _this_props.i18n, _this_props_loading = _this_props.loading, loading = _this_props_loading === void 0 ? false : _this_props_loading, invoiceEstimate = _this_props.invoiceEstimate, _this_props_changeSubscription = _this_props.changeSubscription, changeSubscription = _this_props_changeSubscription === void 0 ? function() {} : _this_props_changeSubscription, renderAsBottomSheet = _this_props.renderAsBottomSheet, disablePayment = _this_props.disablePayment, subscriptionsPrismic = _this_props.subscriptionsPrismic;
                var hasEstimate = !isEmpty(invoiceEstimate);
                return /*#__PURE__*/ _jsxs("div", {
                    className: "row total-with-payment",
                    onClick: this.toggleBottomSheet,
                    onKeyDown: this.toggleBottomSheet,
                    children: [
                        hasEstimate && /*#__PURE__*/ _jsxs("div", {
                            className: "column",
                            children: [
                                /*#__PURE__*/ _jsxs("span", {
                                    className: "total",
                                    children: [
                                        i18n.common.total,
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: "total-price",
                                    children: formatPrice(invoiceEstimate === null || invoiceEstimate === void 0 ? void 0 : invoiceEstimate.amountDue, invoiceEstimate === null || invoiceEstimate === void 0 ? void 0 : invoiceEstimate.currencyCode, stripCurrencyConversion(subscriptionsPrismic))
                                })
                            ]
                        }),
                        !disablePayment && /*#__PURE__*/ _jsx(Button, {
                            classes: {
                                label: "ux-button-label"
                            },
                            className: "button raised half-width pointer",
                            disabled: loading || !hasEstimate,
                            onClick: function(e) {
                                var _this_props_onPay, _this_props;
                                e.stopPropagation();
                                if (renderAsBottomSheet && !_this.state.bottomSheetOpen) {
                                    var _this_bottomSheetRef;
                                    (_this_bottomSheetRef = _this.bottomSheetRef) === null || _this_bottomSheetRef === void 0 ? void 0 : _this_bottomSheetRef.snapTo(0);
                                    return;
                                }
                                changeSubscription();
                                (_this_props_onPay = (_this_props = _this.props).onPay) === null || _this_props_onPay === void 0 ? void 0 : _this_props_onPay.call(_this_props);
                            },
                            children: loading ? /*#__PURE__*/ _jsx(Spinner, {}) : "".concat(i18n.button.pay, " >")
                        })
                    ]
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this_props = this.props, _this_props_loading = _this_props.loading, loading = _this_props_loading === void 0 ? false : _this_props_loading, renderAsBottomSheet = _this_props.renderAsBottomSheet, _this_props_additionalClasses = _this_props.additionalClasses, additionalClasses = _this_props_additionalClasses === void 0 ? "" : _this_props_additionalClasses;
                var warningPrototype = this.renderWarning();
                var bottomSheetFoldedSize = warningPrototype ? 206 : 86;
                var bottomSheetSnapPoints = [
                    0.9,
                    bottomSheetFoldedSize
                ];
                return !renderAsBottomSheet ? /*#__PURE__*/ _jsxs("div", {
                    className: "order-summary-container ".concat(loading ? "loading" : "", " ").concat(additionalClasses),
                    children: [
                        this.renderAddress(),
                        this.renderHeader(),
                        warningPrototype,
                        this.renderMainContent(),
                        this.renderFooterInfo(),
                        this.renderTotalWithPayment()
                    ]
                }) : /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            style: {
                                minHeight: "".concat(bottomSheetFoldedSize, "px"),
                                width: "100%"
                            }
                        }),
                        /*#__PURE__*/ _jsxs(Sheet, {
                            isOpen: true,
                            onClose: function() {
                                var _this_bottomSheetRef;
                                (_this_bottomSheetRef = _this.bottomSheetRef) === null || _this_bottomSheetRef === void 0 ? void 0 : _this_bottomSheetRef.snapTo(1);
                            },
                            snapPoints: bottomSheetSnapPoints,
                            initialSnap: 1,
                            disableDrag: true,
                            ref: function(ref) {
                                _this.bottomSheetRef = ref;
                            },
                            onSnap: function(id) {
                                if (id === 1) {
                                    _this.setState({
                                        bottomSheetOpen: false
                                    });
                                } else {
                                    _this.setState({
                                        bottomSheetOpen: true
                                    });
                                }
                            },
                            // Open on click
                            className: "bottom-sheet",
                            children: [
                                /*#__PURE__*/ _jsxs(Sheet.Container, {
                                    children: [
                                        /*#__PURE__*/ _jsx(Sheet.Header, {
                                            onDragStart: function() {
                                                _this.setState({
                                                    bottomSheetOpen: true
                                                });
                                            },
                                            onClick: this.toggleBottomSheet,
                                            children: /*#__PURE__*/ _jsxs("div", {
                                                className: "order-summary-sheet-header",
                                                children: [
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "sheet-header-arrow-container ".concat(this.state.bottomSheetOpen ? "open" : ""),
                                                        children: [
                                                            /*#__PURE__*/ _jsx("span", {
                                                                className: "sheet-header-separator left"
                                                            }),
                                                            /*#__PURE__*/ _jsx("span", {
                                                                className: "sheet-header-separator right"
                                                            })
                                                        ]
                                                    }),
                                                    this.props.i18n.order.selectedServices,
                                                    warningPrototype
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Sheet.Content, {
                                            onDragStart: function() {
                                                _this.setState({
                                                    bottomSheetOpen: true
                                                });
                                            },
                                            children: /*#__PURE__*/ _jsxs("div", {
                                                className: "order-summary-container ".concat(loading ? "loading" : "", " ").concat(!this.state.bottomSheetOpen ? "hide-info" : "", " ").concat(additionalClasses),
                                                children: [
                                                    this.renderHeader(),
                                                    this.renderMainContent(),
                                                    this.renderFooterInfo(),
                                                    this.renderTotalWithPayment()
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(Sheet.Backdrop, {})
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return OrderSummary;
}(Component);
var mapStateToProps = function(param) {
    var i18n = param.i18n, userDetails = param.userDetails, screenType = param.screenType;
    return {
        i18n: i18n,
        userDetails: userDetails,
        screenType: screenType
    };
};
var withForwardedRef = function(Comp) {
    var handle = function(props, ref) {
        return /*#__PURE__*/ _jsx(Comp, _object_spread_props(_object_spread({}, props), {
            ref: ref
        }));
    };
    var name = Comp.displayName || Comp.name;
    handle.displayName = "withForwardedRef(".concat(name, ")");
    return /*#__PURE__*/ React.forwardRef(handle);
};
export default withForwardedRef(connect(mapStateToProps, {})(OrderSummary));
